var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getGameRefParameter, getLobbyIdParameter, getParameter } from "../../getParameter";
export const fetchClientConfig = (pathConfig) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    try {
        const clientConfigUrl = pathConfig.clientconfigurl;
        if (clientConfigUrl === undefined || clientConfigUrl === "") {
            return {};
        }
        const endpoint = new URL(clientConfigUrl, document.baseURI);
        const parameters = {
            gameref: (_a = getGameRefParameter()) !== null && _a !== void 0 ? _a : getLobbyIdParameter(),
            jurisdiction: getParameter("jurisdiction"),
            partnerid: getParameter("partnerid"),
            channel: getParameter("channel")
        };
        Object.keys(parameters).forEach((key) => {
            var _a, _b;
            endpoint.searchParams.set(key, (_b = (_a = parameters[key]) !== null && _a !== void 0 ? _a : endpoint.searchParams.get(key)) !== null && _b !== void 0 ? _b : "");
        });
        const response = yield fetch(endpoint.toString());
        if (!response.ok) {
            throw new Error(`getClientConfig fetch failed (status ${response.status.toString()})`);
        }
        const data = yield response.json();
        if (typeof data === "object" && data !== null && !Array.isArray(data)) {
            return data;
        }
        throw new Error("getClientConfig response was not an object");
    }
    catch (error) {
        console.warn("Unable to load client config", error);
        return {};
    }
});
